// @flow
import styled from 'styled-components';
import { ReactComponent as HelpBubble } from '../../static-icons/help-bubble.svg';
import { TooltipTheme } from '../../tooltip';
/*::
import type { InfoBubbleThemeType } from '..';
*/

var thm
/*: InfoBubbleThemeType */
= {
  TooltipReference: styled.div.withConfig({
    displayName: "theme__TooltipReference",
    componentId: "sc-1gmd14d-0"
  })(["position:relative;display:inline-flex;align-items:center;&:hover [data-css=hoverable]{visibility:visible;opacity:1;}"]),
  InfoIcon: styled(HelpBubble).withConfig({
    displayName: "theme__InfoIcon",
    componentId: "sc-1gmd14d-1"
  })(["width:1.4rem;margin-left:3px;"]),
  InfoBubbleTooltipTheme: Object.assign({}, TooltipTheme, {
    TransparentOffset: styled(TooltipTheme.TransparentOffset).attrs({
      'data-css': 'hoverable'
    }).withConfig({
      displayName: "theme__TransparentOffset",
      componentId: "sc-1gmd14d-2"
    })(["visibility:hidden;opacity:0;transition-duration:0.5s;"]),
    Main: styled(TooltipTheme.Main).withConfig({
      displayName: "theme__Main",
      componentId: "sc-1gmd14d-3"
    })(["width:16rem;"])
  })
};
export default thm;